import { AutoMap } from "@automapper/classes"
import { EBuildingType } from "../enums/building-type";

export class Work {
    @AutoMap()
    StartDate!: Date
    @AutoMap()
    BuildingType: EBuildingType = EBuildingType.Other
    @AutoMap()
    BuildingTypeOther: string = ''

    public constructor(init?: Partial<Work>) {
        Object.assign(this, init);
    }
}